module.exports = __webpack_public_path__ + "static/media/nino.ff1a63e3.png";